import React, { useState } from "react";
import axios from "axios";

export default function EditUser({ user, onUserUpdated }) {
  const [show, setShow] = useState(false);
  const [form, setForm] = useState({
    full_name: user.full_name,
    phone: user.phone,
    role: user.role
  });

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`/api/auth/users/${user.id}`, form);
      setShow(false);
      if (onUserUpdated) onUserUpdated();
    } catch (err) {
      console.error("خطأ في التعديل:", err);
    }
  };

  return (
    <>
      <button className="edit-btn" onClick={() => setShow(!show)}>
        ✏ تعديل
      </button>

      {show && (
        <form onSubmit={handleSubmit} className="edit-user-form">
          <input
            type="text"
            name="full_name"
            value={form.full_name}
            onChange={handleChange}
            required
          />

          <input
            type="text"
            name="phone"
            value={form.phone}
            onChange={handleChange}
            required
          />

          <select name="role" value={form.role} onChange={handleChange}>
            <option value="customer">زبون</option>
            <option value="admin">مدير</option>
            <option value="hotel">فندق</option>
            <option value="delivery">توصيل</option>
          </select>

          <button type="submit" className="save-btn">
            💾 حفظ
          </button>
        </form>
      )}

      {/* === CSS داخل نفس الملف === */}
      
    </>
  );
}
